<template>
  <a href="#" @click.prevent="tryDeleteNote"><i class="fa fa-trash"></i></a>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      deleteNote: "deleteNote"
    }),
    async tryDeleteNote(e) {
      e.stopPropagation();
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-light-blue",
          cancelButton: "btn text-medium-grey"
        },
        buttonsStyling: false,
        showClass: {
          popup: "animated zoomIn"
        },
        hideClass: {
          popup: "animated zoomOut"
        }
      });

      const result = await swalWithBootstrapButtons.fire({
        title: "Are you sure?",
        text: "This note will be deleted permanently",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        reverseButtons: true
      });
      if (result.isConfirmed) {
        this.$emit("delete");
        await this.deleteNote(this.id);
        if (!this.$route.path.includes("/dashboard"))
          this.$router.push("/dashboard");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
